import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=65091b7a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=65091b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65091b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65091b7a')) {
      api.createRecord('65091b7a', component.options)
    } else {
      api.reload('65091b7a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=65091b7a&scoped=true&", function () {
      api.rerender('65091b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SvDqDl83re7W/JS/teamMember.vue"
export default component.exports